import {
	DOCUMENT_TYPE_OPTIONS,
	VEHICLE_DOCUMENT_DOT_COLORS,
	VEHICLE_DOCUMENT_STATUS_COLORS,
	VEHICLE_DOCUMENT_STATUS_LABELS,
} from "../constants";
import type { VehicleDocumentStatus, VehicleDocumentTypeId } from "../types";

export const vehicleDocumentTypeIdLabel = (type: VehicleDocumentTypeId) =>
	DOCUMENT_TYPE_OPTIONS.find((option) => option.id === type)?.label ?? "";

export const vehicleDocumentStatusLabel = (status: VehicleDocumentStatus) =>
	VEHICLE_DOCUMENT_STATUS_LABELS[status];

export const vehicleDocumentStatusDotColor = (status: VehicleDocumentStatus) =>
	VEHICLE_DOCUMENT_DOT_COLORS[status];

export const vehicleDocumentStatusColor = (status: VehicleDocumentStatus) =>
	VEHICLE_DOCUMENT_STATUS_COLORS[status];
